<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<div class="frame">
<p class="Prompt_-Writing-Prompts--Heading">Writing Prompts: </p>
<p class="Prompt_-Prompts-Name--Heading">Gaining Perspective</p>
<p class="Prompt_Prompt-Intro-Para">These exercises will help you review your life and gain a different kind of perspective on your past which can help you project into a brighter future for yourself. The word “perspective” implies clear vision and understanding, so when you complete these entries, keep that in mind. Part of what makes journaling such a positive activity is that it teaches you about yourself, who you are, and what makes you tick. Getting to know yourself is a process that many of us don’t think to engage in, but it’s one that will help seal your individuality and create a better understanding of your foundation<span class="noBreak">al</span><span class="noBreak"> </span><span class="noBreak">traits.</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// BlackAndResilient6.vue?7883d419